import { Button, Flex, Popover, Tooltip } from "antd";
import cx from "classnames";
import styles from "./ChatWithAi.module.scss";
import { TypeAnimation } from "react-type-animation";
import React, { FC, useCallback, useState } from "react";
import { WarningOutlined } from "@ant-design/icons";

const ChatWithAiMessage: FC<{
  info?: string | undefined;
  active: boolean;
  message: { role: string; text: string; translate?: string };
  onCompleted: () => any;
}> = ({ message, onCompleted, active, info }) => {
  const [isCompleted, setCompleted] = useState(false);

  const onTextCompleted = useCallback(() => {
    setCompleted(true);
    onCompleted();
  }, [onCompleted]);

  return (
    <Flex justify={message.role === "model" ? "flex-start" : "flex-end"}>
      {info && (
        <Popover title={<div dangerouslySetInnerHTML={{ __html: info }} />}>
          <Button danger type={"text"} icon={<WarningOutlined />} />
        </Popover>
      )}

      <div className={cx(styles.chatWithAi__message, { [styles.chatWithAi__message_isLeft]: message.role === "model" })}>
        <Tooltip trigger={"click"} title={message.translate}>
          {!active || message.role === "user" || isCompleted ? (
            <div dangerouslySetInnerHTML={{ __html: message.text }} />
          ) : (
            <TypeAnimation cursor={false} sequence={[message.text, onTextCompleted]} />
          )}
        </Tooltip>
      </div>
    </Flex>
  );
};

export default ChatWithAiMessage;
